// @flow
import React from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { PasswordInput } from 'design-system/src/components/Input/Input'

interface PropsType extends InjectedIntlProps {
  id: string
  label?: string
}

export const PasswordField = (props: PropsType) => (
  <PasswordInput
    data-qa='password'
    id={props.id}
    label={props.intl.formatMessage({ id: 'login.password' })}
    required={true}
  />
)

export default injectIntl(PasswordField)
